import { render, staticRenderFns } from "./AcknoledgementLetter.vue?vue&type=template&id=1299781c"
import script from "./AcknoledgementLetter.vue?vue&type=script&lang=js"
export * from "./AcknoledgementLetter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports